import {ProfileChecklistItem} from "./ProfileChecklistItem";
import {getNextOnboardingStep, profileIsReadyToPublish, profileValidations} from "../../WebsiteValidator";
import React, {useContext} from "react";
import {ProviderProfileContext} from "../../../../ProviderProfileProvider";
import {TabbedPageHeader} from "../../../../components/TabbedPageHeader";
import {Link} from "react-router-dom";

/**
 * When the business profile has never published a website they get this.
 * @constructor
 */
export const CompletionChecklist = () => {

  const {business, businessProfile} = useContext(ProviderProfileContext);

  return <div className={'NonScrollingToolPage'}>
    
    <div className={'ProviderToolAreaContent'}>

      <h1 style={{marginBlockStart: 0}}>Welcome to Kensu!</h1>

      <div>You're just a few steps away from completing your profile and going live. Here’s how to get set up:</div>

      <br/>

      <div className={'CompleteProfileChecklist'}>

        {profileValidations
            .filter(validation => validation.isRequired(business))
            .map((validation, i) => {

              const issues = validation.issues(business, businessProfile);

              return <ProfileChecklistItem
                  key={`validation-${i}`}
                  index={i}
                  title={validation.title}
                  description={validation.description(business)}
                  completed={issues.length == 0}
                  link={validation.link}
                  todos={issues}/>
            })}

      </div>
    </div>
  </div>
}